import { useGeoValue } from '@entities/geo';
import { TOrderType } from '@entities/orders';
import { TUserRoles, useUserRole } from '@entities/user';
import ModalOpenBtn from '@features/modal-open-btn';
import RefreshBtn from '@features/refresh-btn';
import { TableControlMenu } from '@features/table-control-menu';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { MenuItem } from '@mui/material';

import { CreateManualOrder } from './CreateManualOrder';
import { OrdersDownloadBtn } from './DownloadBtn';
import { OrdersResendBtn } from './ResendBtn';

type TProps = {
  type: TOrderType;
  refetch: () => void;
};

// Manual deposit creation is an Argentina-only flow for admins and internal operators
// (useUserRole already reports external operators as 'provider')
const MANUAL_ORDER_ROLES: TUserRoles[] = ['admin', 'operator'];

export const BulkOrders = ({ type, refetch }: TProps) => {
  const geo = useGeoValue();
  const userRole = useUserRole();

  const canCreateManualOrder =
    type === 'deposit' && geo === 'ars' && MANUAL_ORDER_ROLES.includes(userRole);

  return (
    <TableControlMenu>
      <MenuItem>
        <RefreshBtn refetch={refetch} />
      </MenuItem>
      <MenuItem>
        <OrdersDownloadBtn />
      </MenuItem>
      {canCreateManualOrder && (
        <MenuItem>
          <ModalOpenBtn
            text='Add balance'
            icon={<AddCircleIcon />}
            modalContent={<CreateManualOrder refetch={refetch} />}
            size='sm'
          />
        </MenuItem>
      )}
      <MenuItem>
        <OrdersResendBtn />
      </MenuItem>
    </TableControlMenu>
  );
};
